<template>
  <div class="introduce">
  <div class="rule">
    <h3>收益说明</h3>
    <dl>
      <dd>花生日记所示或所提及的“消费佣金”、“预估佣金”均统一更改为“预估收益”。该收益系花生日记之外的第三方就淘宝或天猫交易所设置和提供，非由花生日记提供。除前述外，其他使用规范仍依照《花生日记用户协议》及《运营商协议》的相关条款执行。本说明自发布之日起生效。</dd>
    </dl>
<!--     <dl>
      <dt>关于推广奖励</dt>
      <dd>1. 您的花生会员升级为超级会员后，您将获得39.6元的推广奖励；</dd>
      <dd>2. 奖励金额会即时转入您的余额中，您可以通过绑定支付宝随时申请提现，申请后收益将在48小时内到账；</dd>
    </dl> -->
    <dl>
      <dt>关于收益:</dt>
      <dd>(1) 您或您的粉丝领券下单并确认收货后，您将获得收益；</dd>
      <dd>(2) 每月25日将结算上一个自然月确认收货的订单，未确认收货的订单将在下月25日结算，结算后的收益将自动计入您的余额中，您可以通过绑定支付宝随时申请提现，申请后收益将在48小时内到账；</dd>
      <dd>(3) 当出现取消订单、退货退款、或者因订单异常等情况时，将相应扣除收益，实际根据系统结算为准。</dd>
    </dl>
    <h3>名词解析</h3>
    <ul>
      <li>1. 累计收益：累计结算的收益；</li>
      <li>2. 结算收入（上月收益）：上个月内确认收货的订单收益，每月25日结算后，将累计到余额中；</li>
      <li>3. 预估收入（本月收益）：本月内创建的所有订单预估收益；</li>
      <li>4. 预估收入（上月收益）：上月内创建的所有订单预估收益；</li>
      <li>5. 今日预估收入：今日所有订单预估收益；</li>
      <li>6. 昨日预估收入：昨日所有订单预估收益；</li>
      <li>7. 付款笔数：今天内所有付款的订单数量，包含有效订单和失效订单；</li>
      <li>8. 失效订单：取消付款、退货退款、申请维权或因订单异常，均为失效订单；</li>
      <li>9. 自然月：自然月是指每个月的1号到该月的最后一天。</li>
    </ul>
  </div>
  
</div>
</template>

<script>
export default {
  name: 'introduce',
  mounted() {
    document.title = "规则说明"
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.introduce{background: #f42f19; height: 100%;overflow: hidden; }
.rule{
  background: #fff; margin:0 0.75rem;  padding: 0.75rem 0.5rem; color: #333; overflow: scroll; position: absolute; top:0.75rem; bottom: 0.75rem;line-height: 1.5rem;
}
.rule h3{font-size: 0.85rem; position: relative; margin-bottom: 1.0rem;}
.rule h3:after{content: '';display: block; width: 1.75rem; height: 0.25rem; background: #f42f19; position: absolute; bottom: -0.45rem; left: 0.25rem;}
.rule dl,.rule li{font-size: 0.75rem; margin-bottom: 1.25rem;line-height: 1.125rem; }
.rule dt{font-weight: bold}
.rule dd{ text-align: left;}
.rule li{margin-bottom: 0;}
</style>



// WEBPACK FOOTER //
// src/components/introduce.vue